import { useAtomValue } from "jotai";
import { createPortal } from "react-dom";
import VipUpgradeProvider from "@/features/user-vip/modules/provider";
import { globalModalListAtom } from "./store";
import GlobalModal from "./components/modal";

export default function GlobalModalProvider() {
  const modalList = useAtomValue(globalModalListAtom);
  return (<>
    {/* 业务相关 */}
    <VipUpgradeProvider />
    {/* 弹窗相关 */}
    {modalList?.length > 0 && createPortal(<GlobalModal {...modalList[0]} />, document.body)}
  </>);
}